import { createClient } from '@supabase/supabase-js';
import { validateEnvironment } from '../utils/environment';

// Validate environment on import
const config = validateEnvironment();

export const supabase = createClient(config.REACT_APP_SUPABASE_URL, config.REACT_APP_SUPABASE_ANON_KEY);

export default supabase;
